// extracted by mini-css-extract-plugin
export var chatHtmlText = "_o7-2";
export var chatLink = "_o7-0";
export var chatText = "_o7-1";